import type { JSX } from 'react';

import { Grid } from '@change/ds-layout/next';

import { INFO_CARD_LINKS } from 'src/app/pages/about/main/shared/consts';

import { InfoCardLink } from './components/InfoCardLink';

export function InfoCards(): JSX.Element {
	return (
		<Grid className="mb-16 mt-8">
			{INFO_CARD_LINKS.map((infoCard) => (
				<div
					key={infoCard.icon}
					className="col-span-4 md:col-span-4 md:mb-20 lg:col-span-4 lg:col-start-3 lg:first:col-start-3 lg:last:col-start-7"
				>
					<InfoCardLink {...infoCard} data-qa="about-info-card-link" />
				</div>
			))}
		</Grid>
	);
}
